import { apiRequest } from '../client'
import type { MenuStatus } from '../types'

/** One day a product is planned for. */
export interface MenuProductDay {
  menuId: number
  /** ISO date of the daily menu. */
  menuDate: string
  status: MenuStatus
}

/**
 * A product planned on one of the restaurant's daily menus, with the facts the POS layout editor
 * renders as tile states — so the diff panel can warn before a placement without a second lookup.
 */
export interface MenuProduct {
  sku: string
  /** The menu's name for it: the item's override name when set, else the product's display name. */
  label: string
  productName: string
  active: boolean
  openPrice: boolean
  /** CHG-2026-09-duplicate-product-merge: the primary's SKU when this product is a merged duplicate. */
  mergedIntoSku?: string
  assignedHere: boolean
  priceMissing: boolean
  /** Ascending; a product planned on several days appears once, with several entries here. */
  days: Array<MenuProductDay>
}

export interface MenuProductsResponse {
  /** Inclusive window, resolved in the restaurant's timezone by the server. */
  from: string
  to: string
  items: Array<MenuProduct>
}

export const menuProductsApi = {
  /**
   * Products planned on the restaurant's daily menus from today through today+`days`, drafts
   * included.
   *
   * This is the menu side only, never a diff: the editor subtracts its own live layout, which is
   * what lets an unsaved placement count.
   */
  list: (restaurantId: number, days = 7) =>
    apiRequest<MenuProductsResponse>(
      `/api/v0/admin/restaurants/${restaurantId}/menu-products?days=${days}`,
    ),
}
